module.exports = __webpack_public_path__ + "static/media/busd.9ddfe9d2.svg";